<mat-card
    class="mb-25 tagus-card add-user-wrapper common-form position-relative"
>
    <mat-card-header>
        <h3 class="py-4 px-4">
            <strong>
                Hello, my name is {{user_details?.name}}, I will be conducting your
                Final/Mock interview today. Can you please show me your
                passport?
            </strong>
        </h3>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="interviewForm" (ngSubmit)="onSubmit()">
            <div formArrayName="radioQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('radioQuestions')
                            .controls;
                        let i = index
                    "
                    [formGroupName]="i"
                >
                    <div class="row fw-semibold pb-5">
                        <label class="col-sm-4 label-center">
                            {{ radioQuestionArr[i].question }}
                            <b
                                class="color-red"
                                *ngIf="radioQuestionArr[i]?.isRequired"
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of radioQuestionArr[i]
                                            .options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                        (change)="onChanges(group, i)"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <ng-container
                        formArrayName="subQuestions"
                        *ngIf="group.get('subQuestions').controls.length > 0"
                    >
                        <div class="row border pb-10 mb-15">
                            <div
                                class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-14"
                            >
                                {{ radioQuestionArr[i].subQuestionLabel.label }}
                            </div>
                            <div
                                *ngFor="
                                    let subGroup of group.get('subQuestions')
                                        .controls;
                                    let j = index
                                "
                                [formGroupName]="j"
                                class="row fw-semibold pb-5 mb-5 py-2"
                            >
                                <div class="col-sm-4 label-center">
                                    {{ j + 1 }}.
                                    {{
                                        radioQuestionArr[i].subQuestions[j]
                                            .question
                                    }}
                                    <b
                                        class="color-red"
                                        *ngIf="
                                            radioQuestionArr[i].subQuestions[j]
                                                ?.isRequired
                                        "
                                        >*</b
                                    >
                                </div>
                                <div class="col-sm-8">
                                    <div class="d-flex gap-x-2 flex-wrap">
                                        <ng-container
                                            *ngFor="
                                                let subOption of radioQuestionArr[
                                                    i
                                                ].subQuestions[j].options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                [id]="subOption?.id"
                                                [value]="subOption?.value"
                                                formControlName="answer"
                                            />
                                            <label
                                                [for]="subOption?.id"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div formArrayName="compulsoryQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('compulsoryQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ interviewQuestions[i].primary.heading }}
                        </div>

                        <div class="col-sm-12 px-4 py-4 fw-semibold fs-20">
                            {{ interviewQuestions[i].primary.label }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-6 border py-4">
                            <b>Question</b>
                        </div>
                        <div class="col-sm-6 border py-4">
                            <b>Answers </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="questionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get('questionList')
                                        .controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div
                                    class="col-sm-6 border py-4 fw-semibold"
                                    [innerHTML]="
                                        interviewQuestions[i].questionList[k]
                                            .question
                                    "
                                ></div>

                                <div class="col-sm-6 border py-4">
                                    <quill-editor
                                        [styles]="{ height: '150px' }"
                                        name="html"
                                        placeholder="Write answer..."
                                        formControlName="answer"
                                        [modules]="QuillModules"
                                    ></quill-editor>
                                    <div class="d-flex gap-x-2 flex-wrap">
                                        <ng-container
                                            *ngFor="
                                                let subOption of interviewQuestions[0]
                                                    ?.primary?.options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                id="{{ subOption?.id }}_compulsory_{{ k }}"
                                                [value]="subOption?.value"
                                                formControlName="preparation"
                                            />
                                            <label
                                                for="{{ subOption?.id }}_compulsory_{{ k }}"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            
            <div formArrayName="livingExpenseQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('livingExpenseQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ livingExpenseQuestions[i].primary.heading }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-6 border py-4">
                            <b>Question</b>
                        </div>
                        <div class="col-sm-6 border py-4">
                            <b>Answers </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="livingQuestionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get('livingQuestionList')
                                        .controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div
                                    class="col-sm-6 border py-4 fw-semibold"
                                    [innerHTML]="
                                        livingExpenseQuestions[i].questionList[
                                            k
                                        ].question
                                    "
                                ></div>

                                <div class="col-sm-6 border py-4">
                                    <quill-editor
                                        [styles]="{ height: '150px' }"
                                        name="html"
                                        placeholder="Write answer..."
                                        formControlName="answer"
                                        [modules]="QuillModules"
                                    ></quill-editor>
                                    <div class="d-flex gap-x-2 flex-wrap">
                                        <ng-container
                                            *ngFor="
                                                let subOption of livingExpenseQuestions[0]
                                                    ?.primary?.options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                id="{{ subOption?.id }}_livingexpense_{{ k }}"
                                                [value]="subOption?.value"
                                                formControlName="preparation"
                                            />
                                            <label
                                                for="{{ subOption?.id }}_livingexpense_{{ k }}"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div formArrayName="financialQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('financialQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ financialQuestions[i].primary.heading }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-6 border py-4">
                            <b>Question</b>
                        </div>
                        <div class="col-sm-6 border py-4">
                            <b>Answers </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="financialQuestionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get(
                                        'financialQuestionList'
                                    ).controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div
                                    class="col-sm-6 border py-4 fw-semibold"
                                    [innerHTML]="
                                        financialQuestions[i].questionList[k]
                                            .question
                                    "
                                ></div>

                                <div class="col-sm-6 border py-4">
                                    <quill-editor
                                        [styles]="{ height: '150px' }"
                                        name="html"
                                        placeholder="Write answer..."
                                        formControlName="answer"
                                        [modules]="QuillModules"
                                    ></quill-editor>
                                    <div class="d-flex gap-x-2 flex-wrap">
                                        <ng-container
                                            *ngFor="
                                                let subOption of financialQuestions[0]
                                                    ?.primary?.options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                id="{{ subOption?.id }}_financial_{{ k }}"
                                                [value]="subOption?.value"
                                                formControlName="preparation"
                                            />
                                            <label
                                                for="{{ subOption?.id }}_financial_{{ k }}"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div formArrayName="additionalQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('additionalQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ additionalQuestions[i].primary.heading }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-6 border py-4">
                            <b>Question</b>
                        </div>
                        <div class="col-sm-6 border py-4">
                            <b>Answers </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="additionalQuestionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get(
                                        'additionalQuestionList'
                                    ).controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div
                                    class="col-sm-6 border py-4 fw-semibold"
                                    [innerHTML]="
                                        additionalQuestions[i].questionList[k]
                                            .question
                                    "
                                ></div>

                                <div class="col-sm-6 border py-4">
                                    <quill-editor
                                        [styles]="{ height: '150px' }"
                                        name="html"
                                        placeholder="Write answer..."
                                        formControlName="answer"
                                        [modules]="QuillModules"
                                    ></quill-editor>
                                    <div class="d-flex gap-x-2 flex-wrap">
                                        <ng-container
                                            *ngFor="
                                                let subOption of additionalQuestions[0]
                                                    ?.primary?.options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                id="{{ subOption?.id }}_additional_{{ k }}"
                                                [value]="subOption?.value"
                                                formControlName="preparation"
                                            />
                                            <label
                                                for="{{ subOption?.id }}_additional_{{ k }}"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="row mt-10 py-4" formArrayName="decisionQuestions">
                <div
                    class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-20"
                >
                    {{ decisionQuestionArr[0].primary.heading }}
                </div>
                <div
                    *ngFor="
                        let group of interviewForm.get('decisionQuestions')
                            .controls;
                        let m = index
                    "
                    [formGroupName]="m"
                >
                    <div class="row fw-semibold pb-5 py-4">
                        <label class="col-sm-4 label-center">
                            {{ decisionQuestionArr[0]?.questions[m]?.question }}
                            <b
                                class="color-red"
                                *ngIf="
                                    decisionQuestionArr[0]?.questions[m]
                                        ?.isRequired
                                "
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of decisionQuestionArr[0]
                                            ?.questions[m].options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <button type="submit">Submit</button> -->
        </form>
    </mat-card-content>
</mat-card>
